module.exports = __webpack_public_path__ + "static/media/gas cylinder.4ab868f0.png";